module.exports = __webpack_public_path__ + "static/coding_bootcamp-302e1e5e1e38b2e4f5611e87598d61b2.jpeg";